/**
 * Общие заголовки авторизации для всех API клиентов
 * Поддержка Telegram, VK, Web (browser)
 */

export function getAuthHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  // 1. Telegram WebApp
  const tg = (window as any).Telegram?.WebApp;
  if (tg?.initDataUnsafe?.user?.id) {
    headers['X-Telegram-User-Id'] = String(tg.initDataUnsafe.user.id);
    if (tg.initDataUnsafe.user.username) {
      headers["X-User-Name"] = encodeURIComponent(tg.initDataUnsafe.user.username);
    } else if (tg.initDataUnsafe.user.first_name) {
      headers["X-User-Name"] = encodeURIComponent(tg.initDataUnsafe.user.first_name);
    }
    if (tg.initData) {
      headers['X-Telegram-Init-Data'] = tg.initData;
    }
    return headers;
  }

  // 2. VK Mini App
  const search = window.location.search;
  if (search.includes('vk_user_id')) {
    const params = new URLSearchParams(search);
    const vkUserId = params.get('vk_user_id');
    if (vkUserId) {
      sessionStorage.setItem('vk_user_id', vkUserId);
      headers['X-VK-User-Id'] = vkUserId;
      return headers;
    }
  }
  // VK fallback: после навигации параметры теряются
  const savedVkId = sessionStorage.getItem('vk_user_id');
  if (savedVkId) {
    headers['X-VK-User-Id'] = savedVkId;
    return headers;
  }

  // 3. Browser / Guest
  const BROWSER_ID_KEY = 'beshek_uid';
  const GUEST_ID_KEY = 'beshek_guest_id';

  let browserId = null;
  try {
    browserId = localStorage.getItem(BROWSER_ID_KEY) || localStorage.getItem(GUEST_ID_KEY);
    if (!browserId) {
      browserId = `br_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(BROWSER_ID_KEY, browserId);
    }
  } catch {
    browserId = `br_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  }

  headers['X-Browser-Id'] = browserId;
  return headers;
}
